import '../scss/main.scss';

window.addEventListener('DOMContentLoaded', () => {
	let beforeAfterImageContainers = document.querySelectorAll('.module-before-and-after-image .before-after-image-wrapper');

	if (beforeAfterImageContainers.length < 1) {
		return;
	}

	beforeAfterImageContainers = [].slice.call(beforeAfterImageContainers);

	beforeAfterImageContainers.forEach(container => {
		let observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					container.classList.add('animate');
					observer.unobserve(entry.target);
				}
			});
		}, { threshold: 0.75 });

		observer.observe(container);

		const imageSlider = container.querySelector('.scroller');

		if (!imageSlider) {
			return;
		}

		let active = false;
		imageSlider.addEventListener('mousedown', function(e) {
			e.preventDefault();
			active = true;
			container.classList.remove('animate');
			this.classList.add('scrolling');
		});

		document.body.addEventListener('mouseup', () => {
			active = false;
			imageSlider.classList.remove('scrolling');
		});

		document.body.addEventListener('mouseleave', () => {
			active = false;
			imageSlider.classList.remove('scrolling');
		});

		document.body.addEventListener('mousemove', (e) => {
			if (!active) return;
			e.preventDefault();
			let x = e.pageX;
			x -= container.getBoundingClientRect().left;
			scrollIt(container, x);
		});

		const pan = container.querySelector('.scroller');
		const image = container.querySelector('.before-after-image-image-container:nth-child(2)');
		pan.addEventListener('touchmove', (event) => {
			let clientX = event.touches[0].clientX;
			pan.style.left = clientX - 30 + 'px';
			image.style.width = clientX + 'px';
		}, false);

		scrollIt(container, 150);

		imageSlider.addEventListener('touchstart', () => {
			active = true;
			imageSlider.classList.add('scrolling');
		});
		document.body.addEventListener('touchend', () => {
			active = false;
			imageSlider.classList.remove('scrolling');
		});
		document.body.addEventListener('touchcancel', () => {
			active = false;
			imageSlider.classList.remove('scrolling');
		});

		window.addEventListener('resize',  () =>  {
			scrollIt(container, 150);
		});
	});

	function scrollIt(wrapper, x){
		let transform = Math.max(0,(Math.min(x, wrapper.offsetWidth)));
		wrapper.querySelector('.before-after-image-image-container:nth-child(2)').style.width = transform + 'px';
		wrapper.querySelector('.scroller').style.left = transform - 30 + 'px';
	}
});